import type { LatLon } from "@radar-sim/schema";

/**
 * Coastline polylines derived from OpenStreetMap data via Overpass API,
 * clipped to the weymouth-portland bounding box and Douglas–Peucker simplified
 * at ~33 m tolerance. Re-fetch with /tmp/fetch-coastline.mjs.
 *
 * Convention:
 *   - WEYMOUTH_PORTLAND_MAINLAND is an OPEN polyline along the mainland's seaward edge,
 *     clipped at the bounding-box left/right margins. Renderers close it
 *     by extending to the chart's top edge.
 *   - WEYMOUTH_PORTLAND_ISLANDS are CLOSED polygons (first === last point). Includes
 *     islands and any inland water features that would draw as land.
 *
 * © OpenStreetMap contributors, ODbL.
 */

export const WEYMOUTH_PORTLAND_MAINLAND: ReadonlyArray<LatLon> = [
  { lat: 50.66848, lon: -2.64968 },
  { lat: 50.66577, lon: -2.64244 },
  { lat: 50.65324, lon: -2.61391 },
  { lat: 50.65308, lon: -2.61259 },
  { lat: 50.64459, lon: -2.59427 },
  { lat: 50.61068, lon: -2.52844 },
  { lat: 50.58905, lon: -2.49136 },
  { lat: 50.57646, lon: -2.47204 },
  { lat: 50.57579, lon: -2.47166 },
  { lat: 50.56098, lon: -2.4501 },
  { lat: 50.55881, lon: -2.44846 },
  { lat: 50.5571, lon: -2.44823 },
  { lat: 50.55571, lon: -2.44991 },
  { lat: 50.5527, lon: -2.45141 },
  { lat: 50.55176, lon: -2.45245 },
  { lat: 50.55117, lon: -2.45258 },
  { lat: 50.54968, lon: -2.4516 },
  { lat: 50.54699, lon: -2.45267 },
  { lat: 50.54449, lon: -2.45557 },
  { lat: 50.54228, lon: -2.45678 },
  { lat: 50.54107, lon: -2.45584 },
  { lat: 50.54089, lon: -2.455 },
  { lat: 50.53887, lon: -2.45385 },
  { lat: 50.53721, lon: -2.45489 },
  { lat: 50.53383, lon: -2.45515 },
  { lat: 50.53078, lon: -2.4563 },
  { lat: 50.5275, lon: -2.45618 },
  { lat: 50.52629, lon: -2.45567 },
  { lat: 50.52492, lon: -2.45603 },
  { lat: 50.52194, lon: -2.45914 },
  { lat: 50.51923, lon: -2.46006 },
  { lat: 50.51651, lon: -2.46011 },
  { lat: 50.51614, lon: -2.45961 },
  { lat: 50.51648, lon: -2.45947 },
  { lat: 50.51426, lon: -2.45941 },
  { lat: 50.51295, lon: -2.45672 },
  { lat: 50.51358, lon: -2.45554 },
  { lat: 50.51491, lon: -2.45448 },
  { lat: 50.51503, lon: -2.45352 },
  { lat: 50.51541, lon: -2.45362 },
  { lat: 50.51533, lon: -2.45259 },
  { lat: 50.5162, lon: -2.45258 },
  { lat: 50.51677, lon: -2.45184 },
  { lat: 50.51631, lon: -2.45056 },
  { lat: 50.51683, lon: -2.45053 },
  { lat: 50.51725, lon: -2.44973 },
  { lat: 50.51708, lon: -2.44897 },
  { lat: 50.51781, lon: -2.44887 },
  { lat: 50.51797, lon: -2.44813 },
  { lat: 50.51839, lon: -2.44824 },
  { lat: 50.51854, lon: -2.44746 },
  { lat: 50.51915, lon: -2.44727 },
  { lat: 50.51895, lon: -2.44584 },
  { lat: 50.5197, lon: -2.44545 },
  { lat: 50.51977, lon: -2.44412 },
  { lat: 50.52051, lon: -2.44279 },
  { lat: 50.5209, lon: -2.44241 },
  { lat: 50.52178, lon: -2.44264 },
  { lat: 50.52345, lon: -2.44153 },
  { lat: 50.52505, lon: -2.439 },
  { lat: 50.52637, lon: -2.43795 },
  { lat: 50.53005, lon: -2.4373 },
  { lat: 50.53485, lon: -2.43075 },
  { lat: 50.53795, lon: -2.42845 },
  { lat: 50.53863, lon: -2.42484 },
  { lat: 50.54276, lon: -2.41795 },
  { lat: 50.54821, lon: -2.41732 },
  { lat: 50.54909, lon: -2.41559 },
  { lat: 50.54992, lon: -2.41628 },
  { lat: 50.55106, lon: -2.41569 },
  { lat: 50.55202, lon: -2.41657 },
  { lat: 50.55298, lon: -2.41665 },
  { lat: 50.55308, lon: -2.41729 },
  { lat: 50.55446, lon: -2.41799 },
  { lat: 50.55489, lon: -2.41901 },
  { lat: 50.55838, lon: -2.42133 },
  { lat: 50.55916, lon: -2.42131 },
  { lat: 50.56336, lon: -2.42514 },
  { lat: 50.56367, lon: -2.42467 },
  { lat: 50.56349, lon: -2.42523 },
  { lat: 50.56607, lon: -2.42845 },
  { lat: 50.5675, lon: -2.42826 },
  { lat: 50.56923, lon: -2.42215 },
  { lat: 50.56776, lon: -2.42839 },
  { lat: 50.56843, lon: -2.43148 },
  { lat: 50.56814, lon: -2.43168 },
  { lat: 50.56766, lon: -2.43073 },
  { lat: 50.56815, lon: -2.43697 },
  { lat: 50.5683, lon: -2.43744 },
  { lat: 50.56901, lon: -2.4374 },
  { lat: 50.57002, lon: -2.44091 },
  { lat: 50.57215, lon: -2.44029 },
  { lat: 50.57299, lon: -2.43778 },
  { lat: 50.57239, lon: -2.44036 },
  { lat: 50.5687, lon: -2.44122 },
  { lat: 50.56841, lon: -2.44182 },
  { lat: 50.56856, lon: -2.44266 },
  { lat: 50.56944, lon: -2.44259 },
  { lat: 50.56948, lon: -2.44348 },
  { lat: 50.5686, lon: -2.44372 },
  { lat: 50.56841, lon: -2.44658 },
  { lat: 50.56873, lon: -2.44754 },
  { lat: 50.56973, lon: -2.44756 },
  { lat: 50.56879, lon: -2.44791 },
  { lat: 50.5699, lon: -2.45114 },
  { lat: 50.57057, lon: -2.45137 },
  { lat: 50.57119, lon: -2.45275 },
  { lat: 50.57149, lon: -2.4526 },
  { lat: 50.57055, lon: -2.45352 },
  { lat: 50.57108, lon: -2.45534 },
  { lat: 50.57211, lon: -2.45596 },
  { lat: 50.57111, lon: -2.45762 },
  { lat: 50.57143, lon: -2.46107 },
  { lat: 50.57407, lon: -2.46415 },
  { lat: 50.57722, lon: -2.46611 },
  { lat: 50.57988, lon: -2.46876 },
  { lat: 50.58247, lon: -2.46951 },
  { lat: 50.58273, lon: -2.47149 },
  { lat: 50.57952, lon: -2.46968 },
  { lat: 50.57915, lon: -2.47037 },
  { lat: 50.57789, lon: -2.46939 },
  { lat: 50.57876, lon: -2.47045 },
  { lat: 50.58003, lon: -2.47363 },
  { lat: 50.5917, lon: -2.49159 },
  { lat: 50.59415, lon: -2.49642 },
  { lat: 50.59744, lon: -2.50136 },
  { lat: 50.59785, lon: -2.50323 },
  { lat: 50.60276, lon: -2.51244 },
  { lat: 50.60888, lon: -2.5222 },
  { lat: 50.61411, lon: -2.53166 },
  { lat: 50.61631, lon: -2.53687 },
  { lat: 50.62088, lon: -2.54419 },
  { lat: 50.62341, lon: -2.5499 },
  { lat: 50.63219, lon: -2.56613 },
  { lat: 50.65414, lon: -2.61167 },
  { lat: 50.65499, lon: -2.60693 },
  { lat: 50.65438, lon: -2.6062 },
  { lat: 50.65369, lon: -2.60624 },
  { lat: 50.65412, lon: -2.60491 },
  { lat: 50.65361, lon: -2.60285 },
  { lat: 50.654, lon: -2.59829 },
  { lat: 50.65329, lon: -2.59748 },
  { lat: 50.65189, lon: -2.5977 },
  { lat: 50.65083, lon: -2.60094 },
  { lat: 50.64904, lon: -2.59838 },
  { lat: 50.64772, lon: -2.5952 },
  { lat: 50.64604, lon: -2.58858 },
  { lat: 50.64527, lon: -2.588 },
  { lat: 50.64497, lon: -2.58654 },
  { lat: 50.64436, lon: -2.58642 },
  { lat: 50.64179, lon: -2.58215 },
  { lat: 50.64103, lon: -2.57824 },
  { lat: 50.63896, lon: -2.57464 },
  { lat: 50.6384, lon: -2.57148 },
  { lat: 50.63753, lon: -2.57022 },
  { lat: 50.63811, lon: -2.5663 },
  { lat: 50.63779, lon: -2.56301 },
  { lat: 50.63817, lon: -2.56122 },
  { lat: 50.63752, lon: -2.56057 },
  { lat: 50.63509, lon: -2.56017 },
  { lat: 50.63348, lon: -2.55902 },
  { lat: 50.63082, lon: -2.55806 },
  { lat: 50.63033, lon: -2.55553 },
  { lat: 50.63064, lon: -2.55223 },
  { lat: 50.62986, lon: -2.54896 },
  { lat: 50.6304, lon: -2.54579 },
  { lat: 50.63003, lon: -2.54553 },
  { lat: 50.62947, lon: -2.54609 },
  { lat: 50.62821, lon: -2.54611 },
  { lat: 50.62766, lon: -2.54676 },
  { lat: 50.62825, lon: -2.54944 },
  { lat: 50.62728, lon: -2.55193 },
  { lat: 50.62472, lon: -2.54847 },
  { lat: 50.62479, lon: -2.54738 },
  { lat: 50.62585, lon: -2.54598 },
  { lat: 50.62571, lon: -2.54528 },
  { lat: 50.62512, lon: -2.54461 },
  { lat: 50.62337, lon: -2.54431 },
  { lat: 50.62207, lon: -2.54019 },
  { lat: 50.62038, lon: -2.53931 },
  { lat: 50.61847, lon: -2.53517 },
  { lat: 50.61707, lon: -2.52976 },
  { lat: 50.61681, lon: -2.52498 },
  { lat: 50.61787, lon: -2.52341 },
  { lat: 50.6178, lon: -2.51749 },
  { lat: 50.61714, lon: -2.51659 },
  { lat: 50.61526, lon: -2.51631 },
  { lat: 50.61425, lon: -2.51451 },
  { lat: 50.61156, lon: -2.51472 },
  { lat: 50.61025, lon: -2.51373 },
  { lat: 50.61004, lon: -2.51309 },
  { lat: 50.61158, lon: -2.51045 },
  { lat: 50.61117, lon: -2.50828 },
  { lat: 50.60914, lon: -2.5052 },
  { lat: 50.60862, lon: -2.50533 },
  { lat: 50.60819, lon: -2.5072 },
  { lat: 50.60761, lon: -2.50781 },
  { lat: 50.60624, lon: -2.50706 },
  { lat: 50.6051, lon: -2.50433 },
  { lat: 50.60683, lon: -2.50154 },
  { lat: 50.60633, lon: -2.50119 },
  { lat: 50.60554, lon: -2.50148 },
  { lat: 50.60401, lon: -2.50064 },
  { lat: 50.60285, lon: -2.49564 },
  { lat: 50.6019, lon: -2.49562 },
  { lat: 50.60062, lon: -2.49824 },
  { lat: 50.59892, lon: -2.4994 },
  { lat: 50.59753, lon: -2.49897 },
  { lat: 50.59565, lon: -2.49751 },
  { lat: 50.59118, lon: -2.48826 },
  { lat: 50.59104, lon: -2.48717 },
  { lat: 50.59168, lon: -2.48502 },
  { lat: 50.59113, lon: -2.48406 },
  { lat: 50.59001, lon: -2.48414 },
  { lat: 50.58888, lon: -2.48356 },
  { lat: 50.58859, lon: -2.48097 },
  { lat: 50.58575, lon: -2.47708 },
  { lat: 50.58498, lon: -2.47335 },
  { lat: 50.5845, lon: -2.47233 },
  { lat: 50.58352, lon: -2.47191 },
  { lat: 50.58313, lon: -2.47042 },
  { lat: 50.58389, lon: -2.47017 },
  { lat: 50.58429, lon: -2.47127 },
  { lat: 50.58508, lon: -2.47161 },
  { lat: 50.58526, lon: -2.47051 },
  { lat: 50.58488, lon: -2.47001 },
  { lat: 50.58694, lon: -2.46906 },
  { lat: 50.58828, lon: -2.46766 },
  { lat: 50.59186, lon: -2.46643 },
  { lat: 50.59251, lon: -2.46578 },
  { lat: 50.5932, lon: -2.46439 },
  { lat: 50.59301, lon: -2.4638 },
  { lat: 50.59364, lon: -2.4644 },
  { lat: 50.59433, lon: -2.46339 },
  { lat: 50.59493, lon: -2.46051 },
  { lat: 50.59657, lon: -2.46001 },
  { lat: 50.59739, lon: -2.45893 },
  { lat: 50.59958, lon: -2.45193 },
  { lat: 50.6011, lon: -2.45028 },
  { lat: 50.60062, lon: -2.44757 },
  { lat: 50.60012, lon: -2.44732 },
  { lat: 50.59974, lon: -2.44797 },
  { lat: 50.59955, lon: -2.44766 },
  { lat: 50.60026, lon: -2.4465 },
  { lat: 50.59617, lon: -2.43238 },
  { lat: 50.59926, lon: -2.4425 },
  { lat: 50.59962, lon: -2.44241 },
  { lat: 50.59947, lon: -2.44316 },
  { lat: 50.60115, lon: -2.44866 },
  { lat: 50.60184, lon: -2.44948 },
  { lat: 50.60375, lon: -2.45096 },
  { lat: 50.60447, lon: -2.45072 },
  { lat: 50.60599, lon: -2.44666 },
  { lat: 50.6062, lon: -2.4448 },
  { lat: 50.60722, lon: -2.44308 },
  { lat: 50.60798, lon: -2.44333 },
  { lat: 50.60858, lon: -2.4428 },
  { lat: 50.60808, lon: -2.44372 },
  { lat: 50.60734, lon: -2.45027 },
  { lat: 50.60646, lon: -2.45185 },
  { lat: 50.60731, lon: -2.45536 },
  { lat: 50.60708, lon: -2.45349 },
  { lat: 50.60822, lon: -2.44992 },
  { lat: 50.60859, lon: -2.44566 },
  { lat: 50.60945, lon: -2.44442 },
  { lat: 50.61031, lon: -2.44641 },
  { lat: 50.60872, lon: -2.44998 },
  { lat: 50.61069, lon: -2.45214 },
  { lat: 50.61352, lon: -2.45245 },
  { lat: 50.61505, lon: -2.45193 },
  { lat: 50.61947, lon: -2.44871 },
  { lat: 50.62383, lon: -2.44441 },
  { lat: 50.62385, lon: -2.44334 },
  { lat: 50.62408, lon: -2.4437 },
  { lat: 50.62507, lon: -2.44264 },
  { lat: 50.62982, lon: -2.43613 },
  { lat: 50.63346, lon: -2.42991 },
  { lat: 50.63636, lon: -2.42142 },
  { lat: 50.63646, lon: -2.41972 },
  { lat: 50.63527, lon: -2.41823 },
  { lat: 50.63439, lon: -2.4117 },
  { lat: 50.63319, lon: -2.41035 },
  { lat: 50.63299, lon: -2.40857 },
  { lat: 50.63377, lon: -2.40801 },
  { lat: 50.63487, lon: -2.40476 },
  { lat: 50.6366, lon: -2.39585 },
  { lat: 50.63663, lon: -2.39354 },
  { lat: 50.63568, lon: -2.38616 },
  { lat: 50.63532, lon: -2.37861 },
  { lat: 50.63382, lon: -2.37585 },
  { lat: 50.63115, lon: -2.36554 },
  { lat: 50.63152, lon: -2.35778 },
  { lat: 50.6309, lon: -2.35484 },
  { lat: 50.63124, lon: -2.35185 },
  { lat: 50.63071, lon: -2.3504 },
  { lat: 50.63205, lon: -2.34433 },
  { lat: 50.63203, lon: -2.33918 },
  { lat: 50.63093, lon: -2.33446 },
  { lat: 50.63011, lon: -2.33422 },
  { lat: 50.62676, lon: -2.32998 },
  { lat: 50.62634, lon: -2.32707 },
  { lat: 50.62466, lon: -2.32337 },
  { lat: 50.62572, lon: -2.31959 },
  { lat: 50.62521, lon: -2.3176 },
  { lat: 50.62575, lon: -2.3116 },
  { lat: 50.62499, lon: -2.30263 },
  { lat: 50.62274, lon: -2.29157 },
  { lat: 50.62219, lon: -2.29144 },
  { lat: 50.62223, lon: -2.29092 },
  { lat: 50.62291, lon: -2.2906 },
  { lat: 50.62283, lon: -2.28595 },
  { lat: 50.62208, lon: -2.27814 },
  { lat: 50.62149, lon: -2.27642 },
  { lat: 50.6211, lon: -2.27711 },
  { lat: 50.62097, lon: -2.27521 },
  { lat: 50.62113, lon: -2.27391 },
  { lat: 50.6213, lon: -2.27437 },
  { lat: 50.62175, lon: -2.27407 },
  { lat: 50.62197, lon: -2.273 },
  { lat: 50.62127, lon: -2.27173 },
  { lat: 50.62163, lon: -2.27035 },
  { lat: 50.62112, lon: -2.26698 },
  { lat: 50.61803, lon: -2.2602 },
  { lat: 50.61837, lon: -2.25946 },
  { lat: 50.61781, lon: -2.25649 },
  { lat: 50.61813, lon: -2.2532 },
  { lat: 50.61694, lon: -2.24938 },
  { lat: 50.61693, lon: -2.24801 },
  { lat: 50.61796, lon: -2.24978 },
  { lat: 50.61871, lon: -2.2496 },
  { lat: 50.61934, lon: -2.24837 },
  { lat: 50.61949, lon: -2.24644 },
  { lat: 50.61881, lon: -2.24426 },
  { lat: 50.61802, lon: -2.24371 },
  { lat: 50.61751, lon: -2.24476 },
  { lat: 50.61679, lon: -2.24497 },
  { lat: 50.61661, lon: -2.24601 },
  { lat: 50.61618, lon: -2.24258 },
  { lat: 50.6161, lon: -2.2282 },
  { lat: 50.61681, lon: -2.22831 },
  { lat: 50.61714, lon: -2.22752 },
  { lat: 50.61668, lon: -2.22462 },
  { lat: 50.61698, lon: -2.22297 },
  { lat: 50.61777, lon: -2.2234 },
  { lat: 50.61842, lon: -2.22317 },
  { lat: 50.62009, lon: -2.22042 },
  { lat: 50.6211, lon: -2.20977 },
  { lat: 50.62205, lon: -2.20855 },
  { lat: 50.62231, lon: -2.20731 },
  { lat: 50.62223, lon: -2.2054 },
  { lat: 50.62146, lon: -2.20417 },
  { lat: 50.62238, lon: -2.20037 },
];

export const WEYMOUTH_PORTLAND_ISLANDS: ReadonlyArray<ReadonlyArray<LatLon>> = [
  [
    { lat: 50.58474, lon: -2.414 },
    { lat: 50.58514, lon: -2.41387 },
    { lat: 50.58525, lon: -2.41434 },
    { lat: 50.58455, lon: -2.41523 },
    { lat: 50.5845, lon: -2.41453 },
    { lat: 50.57201, lon: -2.41634 },
    { lat: 50.57087, lon: -2.41738 },
    { lat: 50.56957, lon: -2.42052 },
    { lat: 50.57058, lon: -2.41716 },
    { lat: 50.57195, lon: -2.41587 },
    { lat: 50.58474, lon: -2.414 },
  ],
  [
    { lat: 50.56966, lon: -2.43874 },
    { lat: 50.56953, lon: -2.43662 },
    { lat: 50.56977, lon: -2.43831 },
    { lat: 50.57003, lon: -2.43756 },
    { lat: 50.57006, lon: -2.43381 },
    { lat: 50.57164, lon: -2.43123 },
    { lat: 50.57121, lon: -2.43414 },
    { lat: 50.57115, lon: -2.43311 },
    { lat: 50.56966, lon: -2.43874 },
  ],
  [
    { lat: 50.57412, lon: -2.45412 },
    { lat: 50.57422, lon: -2.45101 },
    { lat: 50.5725, lon: -2.44788 },
    { lat: 50.57195, lon: -2.44757 },
    { lat: 50.56976, lon: -2.44906 },
    { lat: 50.57196, lon: -2.44738 },
    { lat: 50.57433, lon: -2.4509 },
    { lat: 50.57412, lon: -2.45412 },
  ],
];

/** Combined coastline for AreaData.coastline. Index 0 is the mainland;
 *  the rest are closed island polygons. */
export const WEYMOUTH_PORTLAND_COASTLINE: ReadonlyArray<ReadonlyArray<LatLon>> = [
  WEYMOUTH_PORTLAND_MAINLAND,
  ...WEYMOUTH_PORTLAND_ISLANDS,
];
